import InterstitialScreen from './InterstitialScreen';
import { InterstitialScreenSubtitle, InterstitialScreenTitle } from './InterstitialScreen.style';

InterstitialScreen.Title = InterstitialScreenTitle;
InterstitialScreen.Subtitle = InterstitialScreenSubtitle;

export default InterstitialScreen;
